class Forms {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/forms`;

  }

  async createForm(data) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, data);

  }

  async getFormById(formId) {

    const path = `${this.basePath}/:formId`;

    return this.apiClient.get(path, { formId }, {});

  }

  async getFormsByQueryOptions(queryOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async setFormFieldsOrder(formId, fieldsOrder) {

    const path = `${this.basePath}/:formId/fields-order`;

    return this.apiClient.put(path, { formId }, {}, fieldsOrder);

  }

  async updateFormById(formId, data) {

    const path = `${this.basePath}/:formId`;

    return this.apiClient.put(path, { formId }, {}, data);

  }

  async createFormField(formId, field) {

    const path = `${this.basePath}/:formId/fields`;

    return this.apiClient.post(path, { formId }, {}, field);

  }

  async updateFormFieldById(formId, fieldId, field) {

    const path = `${this.basePath}/:formId/fields/:fieldId`;

    return this.apiClient.put(path, { formId, fieldId }, {}, field);

  }

  async deleteFormFieldById(formId, fieldId) {

    const path = `${this.basePath}/:formId/fields/:fieldId`;

    return this.apiClient.delete(path, { formId, fieldId }, {});

  }

}

export default Forms;